export type State = {
  theme: {
    darkmode: boolean;
  };
};

export const state: State = {
  theme: {
    darkmode: true,
  },
};
